import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'
import { foldableSectionMixin } from '../Section/styles'

export const SectionsListContainer = styled.div``

export const SectionsListFooter = styled.div`
  ${foldableSectionMixin}

  padding: 24px 36px 36px;

  ${Media.AboveTablet`
    margin-bottom: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  `};

  ${Media.Phone`
    padding: 16px 20px 36px;
  `};
`

export const AcvBannerContainer = styled.div`
  margin-top: 8px;
`

export const RecommendedStepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Banners = styled.div`
  display: flex;
  gap: 8px;

  ${Media.Phone`
    flex-direction: column;
  `};
`

export const RecommendedSteps = styled.span`
  color: var(--amber-amber-80-ext, #582c0c);
  ${Typography.Caps};
  ${FontWeights.DemiBold};
  padding: 2px 8px;
  border-radius: 4px;
  background-color: ${Colors.Amber20};
  width: fit-content;

  ${Media.Phone`
    display: none;
  `};
`
